import React from 'react';
import PropTypes from 'prop-types';
import {
  FDAccordion,
  FDAccordionDetails,
  FDAccordionTitle,
  FDBodyText, FDBox,
  FDPaper,
  FDStack,
  FDTitleText,
} from '@facet-wealth/design';
import { TitleTextMedium } from 'Packages/FacetDesign/Components';
import MetaLayoutRemainingFields from 'Components/UI/Meta/MetaForm/Components/MetaLayout/MetaLayoutRemainingFields';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { MetaLayoutSubmissionScroller } from 'Components/UI/Meta/MetaForm/Components/MetaLayoutSubmissionScroller';
import { useValidationText } from 'Hooks/useValidationText';

export const AccountItem = ({ expanded, setExpanded }) => {
  const { resource } = useMetaLayoutContext();
  const { valid, validationText } = useValidationText(resource);
  return (
    <MetaLayoutSubmissionScroller scrollToFirstError onHighlight={() => setExpanded(true)}>
      <FDBox paddingY={1}>
        <FDPaper appearance="elevated">
          <FDAccordion
            expanded={expanded}
            onChange={setExpanded}
          >
            <FDAccordionTitle>
              <FDStack justifyContent={'space-between'} flex={1}>
                <FDStack direction={'column'}>
                  <FDTitleText value={resource.attr('name')} />
                  <FDBodyText size={'sm'} value={validationText} color={valid ? 'textDisabled' : 'textAttention'} />
                </FDStack>
                <TitleTextMedium value={resource.attr('balance')} />
              </FDStack>
            </FDAccordionTitle>

            <FDAccordionDetails>
              <MetaLayoutRemainingFields noAccordion horizontal />
            </FDAccordionDetails>
          </FDAccordion>
        </FDPaper>
      </FDBox>
    </MetaLayoutSubmissionScroller>
  );
};

AccountItem.propTypes = {
  expanded: PropTypes.bool.isRequired,
  setExpanded: PropTypes.func.isRequired,
};
